import {Component, computed, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {PERCENTAGE} from './attribute-fulfillment-percentage.types';
import {ModelFieldPercentageComponent} from '../../../inputs/model-field/model-field-percentage/model-field-percentage.component';

@Component({
  selector: 'app-attribute-fulfillment-percentage',
  imports: [TranslocoPipe, ModelFieldPercentageComponent],
  templateUrl: './attribute-fulfillment-percentage.component.html',
})
export class AttributeFulfillmentPercentageComponent {
  readonly score = input.required<number | null>();
  readonly disabled = input.required<boolean>();
  readonly testIdKey = input.required<string>();

  readonly valueChange = output<number | undefined>();

  readonly displayValue = computed(() => {
    const score = this.score();
    return score == undefined ? undefined : score * PERCENTAGE.MULTIPLIER;
  });

  onValueChange(value: number | null): void {
    if (value == null) {
      this.valueChange.emit(undefined);
      return;
    }
    const clamped = Math.max(0, Math.min(100, value));
    this.valueChange.emit(clamped / PERCENTAGE.MULTIPLIER);
  }
}
